import { debounce } from "lodash";
import InputFieldSet from "PFComponents/text/input_field_set";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useState } from "react";

const DEBOUNCE_TIME = 1500;

const SearchItem = ({ label, filter, autofocus, disabled, handleChange, handleBlur, handleFocus, error }) => {
  const [value, setValue] = useState(filter.value);
  const debouncedHandleChange = debounce(handleChange, DEBOUNCE_TIME);

  // we don't want to redefine debouncedHandleChange on each render,
  // and for now handleChange will always change reference
  const onChange = useCallback((value, valueObject) => {
    setValue(value);
    debouncedHandleChange(value, valueObject);
  }, []);

  useEffect(() => {
    setValue(filter.value || "");
  }, [filter.value]);

  return (
    <div style={{ marginLeft: -5, marginRight: -5 }}>
      <InputFieldSet
        controlledValue
        value={value}
        label={label}
        handleChange={onChange}
        autofocus={autofocus}
        handleBlur={handleBlur}
        handleFocus={handleFocus}
        error={error}
        disabled={disabled}
      />
    </div>
  );
};

SearchItem.propTypes = {
  handleChange: PropTypes.func.isRequired,
  filter: PropTypes.shape({
    title: PropTypes.string.isRequired,
    value: PropTypes.string
  }).isRequired,
  error: PropTypes.string,
  autofocus: PropTypes.bool,
  disabled: PropTypes.bool,
  handleBlur: PropTypes.func,
  handleFocus: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
};

SearchItem.defaultProps = {
  autofocus: false
};

export default SearchItem;
